import { Component } from '@angular/core';

@Component({
  selector: 'app-brouillon-cmd-fourn',
  templateUrl: './brouillon-cmd-fourn.component.html',
  styleUrls: ['./brouillon-cmd-fourn.component.scss']
})
export class BrouillonCmdFournComponent {}
